// extracted by mini-css-extract-plugin
export default {"section":"Services_section__k+jTA","services":"Services_services__JeC1b","carts":"Services_carts__nmRZZ","cart":"Services_cart__hZw8M"};